var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsBoolean, IsDateString, IsEnum, IsOptional, IsUrl, IsUUID, } from 'class-validator';
import { BookingDeclineReason } from '../../appointments/enums/booking-decline-reason.enum.js';
import { CancellationReason } from '../../appointments/enums/cancellation-reason.enum.js';
import { NotificationType } from '../enum/notificationType.enum.js';
export class CreateNotificationDto {
    actorId;
    recipientId;
    callId;
    appointmentId;
    exerciseProgramIds;
    invoiceUrl;
    newTherapistId;
    exerciseProgramMessageId;
    previousScheduledStart;
    newScheduledStart;
    type;
    /** Fixed decline reason for a BOOKING_DECLINED notification (PRD #1343). */
    bookingDeclineReason;
    /** The patient's reason for an APPOINTMENT_CANCELLED_BY_PATIENT notification (TM-9535). */
    cancellationReason;
    /**
     * For an APPOINTMENT_CANCELLED_BY_PATIENT notification (TM-9535): whether the
     * whole appointment ended, or the patient only left a group appointment.
     */
    appointmentCancelled;
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "actorId", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "recipientId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "callId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "appointmentId", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateNotificationDto.prototype, "exerciseProgramIds", void 0);
__decorate([
    IsUrl(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "invoiceUrl", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "newTherapistId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "exerciseProgramMessageId", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "previousScheduledStart", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "newScheduledStart", void 0);
__decorate([
    IsOptional(),
    IsEnum(NotificationType),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "type", void 0);
__decorate([
    IsOptional(),
    IsEnum(BookingDeclineReason),
    __metadata("design:type", String)
], CreateNotificationDto.prototype, "bookingDeclineReason", void 0);
__decorate([
    IsOptional(),
    IsEnum(CancellationReason),
    __metadata("design:type", Object)
], CreateNotificationDto.prototype, "cancellationReason", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateNotificationDto.prototype, "appointmentCancelled", void 0);
//# sourceMappingURL=create-notification.dto.js.map